/*=============================================== BadgePage ===============================================*/

import { Badge, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const BadgePage = () => {
    const items: ItemType[] = [
        {
            title: "Empty",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Badge color="primary" size={24} />
                    <Badge color="secondary" size={24} />
                    <Badge color="success" size={24} />
                    <Badge color="danger" size={24} />
                    <Badge color="warning" size={24} />
                    <Badge color="gray" size={24} />
                    <Badge color="black" size={24} />
                    <Badge color="white" size={24} />
                </Flexbox>
            ),
            code: '<Badge color="primary" size={24} />\n<Badge color="secondary" size={24} />\n<Badge color="success" size={24} />\n<Badge color="danger" size={24} />\n<Badge color="warning" size={24} />\n<Badge color="gray" size={24} />\n<Badge color="black" size={24} />\n<Badge color="white" size={24} />',
        },
        {
            title: "With icon",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Badge color="primary" size={48} icon="star" />
                    <Badge color="secondary" size={48} icon="star" />
                    <Badge color="success" size={48} icon="star" />
                    <Badge color="danger" size={48} icon="star" />
                    <Badge color="warning" size={48} icon="star" />
                    <Badge color="gray" size={48} icon="star" />
                    <Badge color="black" size={48} icon="star" />
                    <Badge color="white" size={48} icon="star" />
                </Flexbox>
            ),
            code: '<Badge color="primary" size={48} icon="star" />\n<Badge color="secondary" size={48} icon="star" />\n<Badge color="success" size={48} icon="star" />\n<Badge color="danger" size={48} icon="star" />\n<Badge color="warning" size={48} icon="star" />\n<Badge color="gray" size={48} icon="star" />\n<Badge color="black" size={48} icon="star" />\n<Badge color="white" size={48} icon="star" />',
        },
        {
            title: "With number",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Badge number={300} color="primary" />
                    <Badge number={1} color="secondary" />
                    <Badge number={1} color="success" />
                    <Badge number={1} color="danger" />
                    <Badge number={1} color="warning" />
                    <Badge number={1} color="gray" />
                    <Badge number={1} color="black" />
                    <Badge number={1} color="white" />
                </Flexbox>
            ),
            code: '<Badge number={300} color="primary" />\n<Badge number={1} color="secondary" />\n<Badge number={1} color="success" />\n<Badge number={1} color="danger" />\n<Badge number={1} color="warning" />\n<Badge number={1} color="gray" />\n<Badge number={1} color="black" />\n<Badge number={1} color="white" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsShort,
            default: "primary",
        },
        {
            subtitle: "size",
            type: "number",
            default: 16,
        },
        {
            subtitle: "icon",
            intro: (
                <>
                    Only if <code>number</code> is not defined.{" "}
                    {commonProps.addIconCapital}
                </>
            ),
            type: "string",
        },
        {
            subtitle: "iconSize",
            type: "number",
            default: "size * 0.7",
        },
        {
            subtitle: "number",
            intro: (
                <>
                    Only if <code>icon</code> is not defined.
                </>
            ),
            type: "number",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default BadgePage
